import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { deliveryMethodsResolver } from './pages/orders/core/resolvers/delivery-methods.resolver';
import { authGuard } from './core/guards';
import { MhdListPageComponent } from './pages/articles/mhd-list-page/mhd-list-page.component';
import { LagerbestandPageComponent } from './pages/stores-stocks/lagerbestand-page/lagerbestand-page.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomeModule) },
  { path: 'auth', loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule)},
  { path: 'mobile-app', loadChildren: () => import('./pages/mobile-app/mobile-app.module').then(m => m.MobileAppModule)},
  { path: 'users', loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule)},
  { path: 'suppliers', loadChildren: () => import('./pages/suppliers/suppliers.module').then(m => m.SuppliersModule)},
  { path: 'bulk-containers', loadChildren: () => import('./pages/bulk-containers/bulk-containers.module').then(m => m.BulkContainersModule)},
  { path: 'own-production', loadChildren: () => import('./pages/own-production/own-production.module').then(m => m.OwnProductionModule)},
  { path: 'giftbox-production', loadChildren: () => import('./pages/giftbox-production/giftbox-production.module').then(m => m.GiftboxProductionModule)},
  { path: 'production-orders', loadChildren: () => import('./pages/production-orders/production-orders.module').then(m => m.ProductionOrdersModule)},
  { path: 'production-planning', loadChildren: () => import('./pages/production-planning/production-planning.module').then(m => m.ProductionPlanningModule)},
  { path: 'production-articles', loadChildren: () => import('./pages/production-articles/production-articles.module').then(m => m.ProductionArticlesModule)},
  {
    path: 'orders',
    loadChildren: () => import('./pages/orders/orders.module').then(m => m.OrdersModule),
    resolve: {
      deliveryMethods: deliveryMethodsResolver
    }
  },
  { path: 'articles', loadChildren: () => import('./pages/articles/articles.module').then(m => m.ArticlesModule)},
  { path: 'mhd', component: MhdListPageComponent, canActivate: [authGuard] },
  { path: 'lagerbestand', component: LagerbestandPageComponent, canActivate: [authGuard] },
  { path: 'stores', loadChildren: () => import('./pages/stores/stores.module').then(m => m.StoresModule) },
  { path: 'cartons', loadChildren: () => import('./pages/cartons/cartons.module').then(m => m.CartonsModule) },
  { path: 'reports', loadChildren: () => import('./pages/reports/reports.module').then(m => m.ReportsModule)},
  { path: 'storestocks', loadChildren: () => import('./pages/stores-stocks/storestocks.module').then(m => m.StorestocksModule)},
  { path: 'stock-transfer', loadChildren: () => import('./pages/stock-transfer/stock-transfer.module').then(m => m.StockTransferModule)},
  { path: 'mhd-offers', loadChildren: () => import('./pages/mhd-offers/mhd-offers.module').then(m => m.MhdOffersModule)},
  { path: 'red-list', loadChildren: () => import('./pages/red-list/red-list.module').then(m => m.RedListModule)},
  { path: 'ean', loadChildren: () => import('./pages/ean/ean.module').then(m => m.EanModule)},
  { path: 'flour', loadChildren: () => import('./pages/flour/flour.module').then(m => m.FlourModule)},
  { path: 'planning-production', loadChildren: () => import('./pages/new-item-produktions/new-item-produktions.module').then(m => m.NewItemProduktionsModule)},
  { path: 'etiketten', loadChildren: () => import('./pages/etiketten/etiketten.module').then(m => m.EtikettenModule)},
  { path: 'labels-printer', redirectTo: 'etiketten', pathMatch: 'full' },
  { path: 'tools', loadChildren: () => import('./pages/tools/tools.module').then(m => m.ToolsModule)},
  { path: 'marketing', loadChildren: () => import('./pages/marketing/marketing.module').then(m => m.MarketingModule)},
  { path: 'settings', loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule)},
  { path: 'marketing', loadChildren: () => import('./pages/marketing/marketing.module').then(m => m.MarketingModule)},
  { path: 'seminars', loadChildren: () => import('./pages/seminars/seminars.module').then(m => m.SeminarsModule)},
  { path: 'controlling', loadChildren: () => import('./pages/controlling/controlling.module').then(m => m.ControllingModule)},
  { path: 'inventory', loadChildren: () => import('./pages/inventory/inventory.module').then(m => m.InventoryModule)},
  { path: 'product-setups', loadChildren: () => import('./pages/product-setups/product-setups.module').then(m => m.ProductSetupsModule)},
  { path: 'posters', loadChildren: () => import('./pages/posters/posters.module').then(m => m.PostersModule)},
  { path: 'store-photos', loadChildren: () => import('./pages/store-photos/store-photos.module').then(m => m.StorePhotosModule)},
  { path: 'non-product-labels', redirectTo: 'etiketten', pathMatch: 'full' },
  {
    path: 'complaints',
    loadChildren: () => import('./pages/complaints/complaints.module').then(m => m.ComplaintsModule)
  },
  {
    path: 'recipe-cards-printer',
    loadChildren: () => import('./pages/recipe-cards-printer/recipe-cards-printer.module').then(m => m.RecipeCardsPrinterModule)
  },
  {
    path: 'slns',
    loadChildren: () => import('./pages/slns/slns.module').then(m => m.SlnsModule)
  }
  // { path: 'welcome', loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomeModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
